export enum IndexState {
  /** The index has not been built yet */
  Empty = "empty",
  /** The index is in the process of building or rebuilding */
  Building = "building",
  /** The index has been built and is ready for use */
  Built = "built",
}
